import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgReload = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.369 4.661A9.25 9.25 0 1 1 12 21.25a.75.75 0 0 1 0-1.5A7.75 7.75 0 1 0 5.04 8.593l3.013-1.004a.75.75 0 0 1 .474 1.423l-4.5 1.5a.75.75 0 0 1-.97-.55l-1-4.5a.75.75 0 1 1 1.465-.325l.489 2.2a9.3 9.3 0 0 1 2.358-2.676"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgReload;
